var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{class:[
    'no-print ma-0 visibility-toggle-btn',
    {
      'defaults-only': _vm.onlyHasDefaultItems,
    },
  ],attrs:{"small":"","color":"blue","md-icon":_vm.mdIcon,"md-icon-position":"left","md-icon-class":"mr-2","md-icon-style":_vm.isShowing ? 'outlined' : '',"title":_vm.isShowing ? 'Hide' : 'Show'},on:{"click":function($event){return _vm.$emit('toggle')}}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }